import React from "react";
import {Redirect, Route} from "react-router-dom";

export function RestrictedRoute(props) {
    const { component: Component, isLoggedIn, ...rest } = props;

    const allowed = props => <Component {...props} />;
    const denied = props => {
        const { location } = props;
        return <Redirect to={{
            pathname: '/signin',
            state: { from: location },
        }}
        />;
    };

    return <Route {...rest} render={props => (isLoggedIn ? allowed(props) : denied(props))} />;
}
